import firebase from "firebase/compat/app";
import {PathRef} from "./Core";
import {acervo} from "../lib/acervo";

type ItemTipo = "image" | "document" | "other";

export interface AnexoObject {
  criado_em: firebase.firestore.Timestamp;
  id: string;
  path: string;
  owner: string;
  principal: PathRef;
  data: firebase.firestore.Timestamp;
  descricao: string;
  notas: string;
  uuid: string;
  fileName: string;
  name?: string;
  tipo: ItemTipo;
  rev?: number;
}

export const getTipoFromPath = (path: string): ItemTipo => {
  const ext = acervo.getExtensionFromPath(path);
  switch (ext) {
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return "image";
    case "pdf":
    case "docx":
    case "doc":
    case "xlsx":
    case "xls":
      return "document";
    default:
      return "other";
  }
};
